import { Category } from 'app/services/additional-info/additional-info.model';

export const StudentTableCategoryConfig: Category[] = [
    {
      name: 'Student Demographic',
      expanded: true,
      fields: [
        {
          name: 'Immigrant',
          key: 'immigrant',
          valuePath: 'demographics.immigrant',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.immigrant'
          }
        },
        {
          name: 'Date First Enrolled in US School',
          key: 'dateFirstEnrolledInUsSchool',
          valuePath: 'demographics.dateFirstEnrolledInUsSchool',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.dateFirstEnrolledInUsSchool'
          }
        },
        {
          name: 'Year Entered 9th Grade',
          key: 'yearEntered9thGrade',
          valuePath: 'demographics.yearEntered9thGrade',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.yearEntered9thGrade'
          }
        },
        {
          name: 'Native Language',
          key: 'nativeLanguage',
          valuePath: 'demographics.nativeLanguage',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.nativeLanguage'
          }
        },
        {
          name: 'EL Service Years',
          key: 'elServiceYears',
          valuePath: 'demographics.elServiceYears',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.elServiceYears'
          }
        },
        {
          name: 'Calculated EL Service Years',
          key: 'calculatedElServiceYears',
          valuePath: 'demographics.calculatedElServiceYears',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.calculatedElServiceYears'
          }
        },
        {
          name: 'English Language Background',
          key: 'englishLanguageBackground',
          valuePath: 'demographics.englishLanguageBackground',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.englishLanguageBackground',
            trueValue: 'Yes',
            falseValue: 'No'
          }
        },
        {
          name: 'Race',
          key: 'race',
          valuePath: 'demographics.race',
          selected: false,
          exportColumn: {
            jsonPath: '$.Demographics.race'
          }
        }
      ]
    },
    // {
    //   name: 'Special Ed Options',
    //   expanded: false,
    //   fields: [
    //     {
    //       name: 'Option Level',
    //       key: 'optionLevel',
    //       selected: false,
    //       exportColumn: {
    //         jsonPath: '$.optionLevel'
    //       }
    //     },
    //     {
    //       name: 'Option Number',
    //       key: 'optionNumberInput',
    //       valuePath: 'optionNumber',
    //       selected: false,
    //       exportColumn: {
    //         jsonPath: '$.optionNumber'
    //       }
    //     },
    //     {
    //       name: 'Begin Date',
    //       key: 'specEdBeginDate',
    //       selected: false,
    //       exportColumn: {
    //         jsonPath: '$.specEdBeginDate'
    //       }
    //     },
    //     {
    //       name: 'End Date',
    //       key: 'specEdEndDate',
    //       selected: false,
    //       exportColumn: {
    //         jsonPath: '$.specEdEndDate'
    //       }
    //     }
    //   ]
    // }
  ];